export { ZodiacWheel } from './ZodiacWheel';
export { WheelStyled } from './styled';
